import React, { useRef } from 'react';
import {
  Icon, Button, Message
} from 'base-ui';
import PropTypes from 'prop-types';

import BlogLatestPostsBasic from './BlogLatestPostsBasic';
import AuthorBox from './BlogAuthorBox';
import ShareButtonsFloating from './BlogShareButtonsFloating';

import BoxBibliography from './BoxBibliography';
// data
const author = {
  id: 55,
  name: 'Gema Sánchez Cuevas',
  permalink: 'https://lamenteesmaravillosa.com/autor/valeria-sabater/',
  slug: '/valeria-sabater/',
  picture: 'https://content.lamenteesmaravillosa.com/users/5bbe108030c1ac536a2cd2c5/profile.png',
  social_profiles: {
    facebook: 'https://www.facebook.com',
    twitter: 'https://www.twitter.com',
    linkedin: 'https://www.linkedin.com',
    // instagram: 'https://www.instagram.com'
  },
  shortDescription: 'Psicóloga especializada en clínica y desarrollo infantil y Coach',
  description: '<p>Psicóloga habilitada sanitaria. Número de colegiada: EX - 01253. Doctoranda en la Universidad de Salamanca. Máster en Psicología Clínica y de la Salud. Experta en Intervención Sistémica. Autora y colaboradora en el III Plan de salud mental de Extremadura 2016-2020. Monitora de Educación Sexual. Tutora de prácticas de psicología en la USAL, UPSA y UHU. Colaboradora en diferentes medios de comunicación.</p> <p><strong>Licenciado en Psicología, especialidad Ciencia Cognitiva,</strong> por la<a href="https://www.ucm.es/" target="_blank" rel="noopener noreferrer">Universidad Complutense de Madrid</a> y la <a href="https://www.westernsydney.edu.au/" target="_blank" rel="noopener noreferrer">Universidad de Western Sydney</a> en 2006, habiendo finalizado el primer ciclo de la Licenciatura en Medicina y Cirugía en la Universidad de Zaragoza en 2001. <strong>Máster en Neuropsicología Cognitiva</strong>por la UCM en 2008 y <strong>Postgrado en Neurociencia Aplicada</strong> por la Universidad de Málaga en 2015, además del <strong> Máster Oficial en Dirección de Centros Sociales</strong> homologado en la Comunidad de Madrid (2017).</p><p>Ha escrito varios artículos en publicaciones online, formado parte de programas de radio acerca de la temática de las Enfermedades Raras, <strong>colaborado en proyectos de investigación con el Instituto de Salud Carlos III</strong> expuestos en congresos sobre Alzheimer, redactado temarios oficiales para la <a href="https://www.nebrija.com/" target="_blank" rel="noopener noreferrer">Universidad Antonio Nebrija</a> , colaborado con la <a href="https://www.ucm.es/" target="_blank" rel="noopener noreferrer">UCM</a> y la <a href="http://www.uam.es/" target="_blank" rel="noopener noreferrer">UAM</a> como <strong>Profesor de Prácticas Asociado</strong>, participado en mesas redondas universitarias como ponente (Día Mundial de la Logopedia 2014) y actualmente publica contenido en lengua inglesa para la plataforma <em>ForeverYoung</em>, que pertenece a la empresa para la que también colabora con acciones de Marketing y Comunicación y como <strong>integrante del Departamento de Innovación en Salud</strong>. </p><p>Posee amplia <strong>experiencia clínica</strong> de más de una década, tanto en Psicología Sanitaria como en Neuropsicología, con todos los grupos de edad y patologías -incluyendo el daño cerebral- en clínicas, hospitales, fundaciones y asociaciones. Ha trabajado también en el campo de los RRHH como <strong>Ayudante de Dirección y como Coordinador Insitu de Proyectos Socio-sanitarios en el extranjero.</strong> </p><p>Está actualmente embarcado en un proyecto a nivel nacional para la <strong>elaboración de protocolos de actuación para Esclerosis Múltiple en población infanto-juvenil</strong> en colaboración con la Fundación Contra la Esclerosis Múltiple de Madrid (<a href="https://www.femmadrid.org/fundacion" target="_blank" rel="noopener noreferrer">FEMM</a> ) y el <a href="http://www.madrid.org/cs/Satellite?pagename=HospitalNinoJesus/Page/HNIJ_home" target="_blank" rel="noopener noreferrer">Hospital Niño Jesús.</a></p>'
};

const user = {
  authorsFollow: null,
};

const BlogSingleContent = ({ bookmarked, isPubli }) => {
  const theContent = useRef();

  const followAuthor = (obj) => {
    console.log(obj);
  };

  return (
    <section id="single" className="single-post">
      <div className="main-post">

        {!isPubli && (
          <div id="breadcrumbs">
            <span>
              <span>
                <a href="index.php">Home</a>
                {' '}
                »
                <span>
                  <a href="archive.php"> Health</a>
                  {' '}
                  »
                  <span className="breadcrumb_last">Para los niños el verano significa diversión</span>
                </span>
              </span>
            </span>
          </div>
        )}

        {!isPubli && <h1 className="single-title">Si quieres llevar una vida más sana sigue estos 4 increíbles consejos</h1>}
        <div className="pre-meta">
          <Button rounded size="small" color="grey" textColor="regent-grey" borderColor="grey">Sponsored</Button>
          <Button rounded size="small" color="aqua" textColor="white" borderColor="aqua" className="btn-fact">
            <Icon name="check" prefix="fas" />
            {' '}
  Fact Checked
          </Button>
          { /* TODO ==> put this with the fact Button above in a component
          <Button rounded size="small" color="green" textColor="white" borderColor="green" className="btn-fact"><Icon name="check-double" prefix="fas" /> Evidence Based</Button> */ }
        </div>
        <div className="metas">
          <span className="meta author">
  Por
            {' '}
            <a href="." className="highlight utilitary-border">Stiven Martínez</a>
          </span>
          <span className="meta spacer">&middot;</span>
          <span className="meta author">
            <i className="far fa-calendar"></i>
            {' '}
  9 de Ago, 2018
          </span>
        </div>

        <div className="single-assigned message with-icon blue-border good">
          <i className="fas fa-check-double icon blue-color"></i>
          <span>
  Este artículo ha sido verificado y aprobado por el
            {' '}
            <a href="." className="highlight blue-border"> Dr. Tito Marín </a>
            {' '}
  de la
            {' '}
            <a href="." className="highlight blue-border"> Universidad CES </a>
            {' '}
  el
            <strong> 9 de Agosto de 2018</strong>
  .
          </span>
        </div>

        <blockquote>Para levar una vida más sana es fundamental aprender a encontrar el equilibrio entre el tiempo que le dedicamos a los demás y el que nos dedicamos a nosotros, en todos los aspectos</blockquote>

        <div className="single-featured-image">
          <img alt="" src="https://mejorconsalud.com/wp-content/uploads/2016/02/vida-sana-poco-tiempo.jpg" />
        </div>

        {!isPubli && <ShareButtonsFloating bookmarked={bookmarked} />}

        <ul className="related-links">
          <li><a href=".">Como eliminar el bello de la cara de manera natural</a></li>
          <li><a href=".">Recetas que te ayudan a mejorar la circulación</a></li>
          <li><a href=".">5 posiciones sexuales más placenteras para ellas</a></li>
        </ul>

        <div className="the-content" ref={theContent}>
          <p>
            Con los estilos de vida tan acelerados que llevamos en la actualidad, bien sea por el trabajo, por las actividades de la casa o simplemente por las prisas, muchas veces se nos olvida lo importante que es la salud.
          </p>
          <p>
            Así, tendemos a dejar de lado acciones que, por muy insignificantes que parezcan, son de suma importancia para el bienestar de nuestro organismo.
          </p>
          <p>
            <strong>
              <a href=".">La salud física</a>
              {' '}
  y mental son fundamentales para poder llevar una vida agradable y tranquila.
            </strong>
            {' '}
  Por eso si estás decidida y quieres mejorar tu calidad de vida, sigue estos increíbles consejos que hoy te traemos.
          </p>
          <div className="ad-space">
            <img alt="dummy" src="https://via.placeholder.com/300x250?Text=Banner+300x250" />
          </div>
          <p>Ten en cuenta que solo tú puedes llevar las riendas de tu vida. Así pues, toma las decisiones correctas y ponte a trabajar con estos pequeños consejos en tu bienestar para poder llevar una vida más sana.</p>
          <h2>Consejos para llevar una vida más sana</h2>
          <h3>1. Adopta una nueva alimentación</h3>
          <img alt="" src="https://mejorconsalud.com/wp-content/uploads/2018/05/verduras-carbohidratos-saludables-500x375.jpg" />
          <p>La alimentación es el punto mas importante que hay que tener en cuenta. Una alimentación adecuada sienta la base de una buena salud física y también mental. Si eres de esas personas que llevas una larga lista al mercado y al final terminas comprando comida basura y alimentos procesados, este consejo va dirigido completamente a ti.</p>
          <p>Una de las cosas más importantes para llevar una vida saludable es llevar una dieta equilibrada. En esta se deben incluir todos los tipos de alimento en porciones justas. Por ejemplo, debes añadir en tus platos vegetales todos los días.</p>
          <ul>
            <li>Debes consumir, por lo menos, cinco raciones de verduras cada día, al igual que las frutas, que nunca deben faltar.</li>
            <li>No te olvides de combinarlos con una cantidad suficiente de carnes magras y pescado siempre fresco. Así estarás asegurando un aporte adecuado de vitaminas, minerales y proteínas, de mucha importancia para el organismo.</li>
            <li>Tampoco olvides la proteína de origen vegetal, que la encuentras presente en los cereales, las leguminosas y frutos secos.</li>
            <li>Trata de evitar las grasas y los dulces en exceso, tu cuerpo te lo agradecerá.</li>
          </ul>
          <h3>2. No olvides desayunar</h3>
          <p>Debes tratar de realizar todas tus comidas a la misma hora y jamás olvides desayunar,  por poco tiempo que tengas. Después de todas esas largas horas nocturnas sin comer, el organismo necesita una fuente de energía para poder seguir activo durante todo el día.</p>
          <p>Intenta apostar por un desayuno que te aporte energía, algo de fibra y proteína para arrancar la mañana con los nutrientes necesarios.</p>

          <Message iconName="info-circle" color="grey" textColor="regent-grey" iconPrefix="fas">
            Content created by Mejor con Salud and sponsored by our partners.
            {' '}
            <a href="." className="regent-grey-color">Learn more</a>
          </Message>
          <Message iconName="info-circle" color="grey" textColor="regent-grey" iconPrefix="fas">
            Content created by Mejor con Salud and sponsored by our partners. Content created by Mejor con Salud and sponsored by our partners. Content created by Mejor con Salud and sponsored by our partners. Content created by Mejor con Salud and sponsored by our partners. Content created by Mejor con Salud and sponsored by our partners. Content created by Mejor con Salud and sponsored by our partners. Content created by Mejor con Salud and sponsored by our partners.
            {' '}
            <a href="." className="regent-grey-color">Learn more</a>
          </Message>
          <div className="message with-icon sponsored-disclaimer grey-bg regent-grey-color">
            <Icon name="info-circle" prefix="fas" className="icon" />
            <span>
              Content created by Mejor con Salud and sponsored by our partners.
              {' '}
              <a href="." className="regent-grey-color">Learn more</a>
            </span>
          </div>
        </div>

        <form className="card medium">
          <div className="row">
            <div className="col-xs-12">
              <div className="section-title align-center" style={{ borderTopColor: '#2E4156' }}>
                <h3 className="label main-font without-margin">Recibe tu primera clase gratuita de natación</h3>
              </div>
            </div>
            <div className="col-xs-12 col-sm-6">
              <input placeholder="Nombre" className="input full" type="text" />
            </div>
            <div className="col-xs-12 col-sm-6">
              <input placeholder="Apellidos" className="input full" type="text" />
            </div>
            <div className="col-xs-12">
              <input placeholder="Correo electrónico" className="input full" type="email" />
            </div>
            <div className="col-xs-12" style={{ marginTop: '10px', marginBottom: '10px' }}>
              <label htmlFor="c1" className="normal-font">
                <input id="c1" type="checkbox" value="" />
                <small>
  He leído y acepto la
                  <a href="." className="highlight grey-border">política de privacidad</a>
                </small>
              </label>
            </div>
            <div className="col-xs-12">
              <Button className="btn white-color transparent-border" style={{ background: '#A12F33' }}>Descargar</Button>
            </div>
          </div>
        </form>

        <div className="mc-featured-container card recommended-post">
          <div id="post-203588">
            <div className="mc-featured-image">
              <a href=".">
                <img src="//mejorconsalud.com/wp-content/uploads/2018/02/Hábitos-extremadamente-fáciles-para-ser-saludable.jpg" alt="Hábitos extremadamente fáciles para ser saludable" />
              </a>
            </div>
            <div className="mc-featured-content">
              <a href=".">
                <h4 className="mc-featured-title">Hábitos extremadamente fáciles para ser saludable</h4>
                <div className="mc-featured-description">
                  Ser saludable es la intención de todos pero sabemos bien que las actividades diarias, los compromisos laborales y la rutina pueden hacer que sea complicado.
                  {' '}
                  <span className="mc-read-more-featured">Leer más »</span>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="single-bibliography">
          <BoxBibliography data={[]} label="Ver bibliografía" />
          {/* <div className="message bibliography">
            <ul>
              <li>
                <strong>Kleinberg L, Kelly R, Yang S, Wang JS, Forastiere AA. Cancer of the esophagus.</strong>
                {' '}
  In: Niederhuber JE, Armitage JO, Doroshow JH, Kastan MB, Tepper JE, eds.&nbsp;
                <em>Abeloff&apos;s Clinical Oncology</em>
  . 5th ed. Philadelphia, PA: Elsevier Saunders; 2014:chap 74.
              </li>
              <li>
                <strong>National Comprehensive Cancer Network website.</strong>
                {' '}
  NCCN clinical practice guidelines in oncology (NCCN guidelines): esophageal and esophagogastric junction cancers. Version 1.2017. nccn.org/professionals/physician_gls/pdf/esophageal.pdf.
              </li>
              <li>
                <strong>National Cancer Institute website.</strong>
                {' '}
  Esophageal cancer treatment (PDQ) - health professional version.
                <a href="http://cancer.gov/cancertopics/pdq/treatment/esophageal/HealthProfessional">cancer.gov/cancertopics/pdq/treatment/esophageal/HealthProfessional</a>
  .
              </li>
            </ul>
          </div> */}
        </div>

        {/* Hide the element
        <div className="tags hidden">
          <span className="title">Categorias:</span>
          <a href=".">Consejos para el hogar</a>
        </div>

        <div className="tags hidden">
          <span className="title">Etiquetas:</span>
          <a href=".">Armarios</a>
          <a href=".">Consejos</a>
          <a href=".">Organizar ahora</a>
        </div>
      */ }

        <AuthorBox
          author={author}
          followAuthor={(v) => followAuthor(v)}
          user={user}
        />
        { /* Hide the element
        <div className="post_neighbors_container_wrapper">
          <div className="post_neighbors_container">
            <a href="." className="neighbors_link previous_post">
              <p className="np-article"><i className="fas fa-arrow-left"></i> Anterior</p>
              <p className="title-article">10 tips para ordenar y organizar la ropa de tu armario</p>
            </a>
            <a href="." className="neighbors_link next_post">
              <p className="np-article">Siguiente <i className="fas fa-arrow-right"></i></p>
              <p className="title-article">Si quieres llevar una vida más sana sigue estos 4 increíbles consejos</p>
            </a>
          </div>
        </div>
      */ }
      </div>

      <div id="related-courses" className="related-courses-style-2 margin-bottom-big">
        { /* <?php include 'template-parts/widgets/related-courses-2.php'; ?> */ }
        <hr className="transparent-bg" />
      </div>

      { /* Related courses v1 Hidden
      <div className="related-courses margin-bottom-big">
        <div className="section-title">
          <span className="label titles-color text-uppercase">Cursos relacionados</span>
        </div>
        <?php // include 'template-parts/widgets/related-courses.php'; ?>
        <hr className="transparent-bg">
      </div>
      */ }

      <div className="related-posts margin-top-big">
        <div className="section-title">
          <span className="label titles-color text-uppercase">Podrían gustarte</span>
        </div>
        <BlogLatestPostsBasic />
        { /* <?php include 'template-parts/widgets/latest-posts-basic.php'; ?> */ }
      </div>

      <div className="comments">
        <hr />
        <div className="fb-comments" data-href="https://developers.facebook.com/docs/plugins/comments#configurator" data-width="100%" data-numposts="10"></div>
        <br />
        <br />
      </div>

      <div className="taboola-posts">
        <br />
        <div className="section-title">
          <span className="label titles-color text-uppercase">Te puede gustar</span>
        </div>
        <div id="ad-spot">
          Espacio para Taboola Feed
        </div>
        <br />
      </div>
    </section>
  );
};

BlogSingleContent.defaultProps = {
  bookmarked: false
};

BlogSingleContent.propTypes = {
  bookmarked: PropTypes.bool
};

export default BlogSingleContent;
